import {combineReducers} from 'redux';
import type {Lead, LeadId, ListItem} from '../types';
import type {ListSchemaResponse} from '../schema/schema-types';
import {reduceListItemsByEntityId} from '../list-items/list-items-utils';
import {addItemsToByIdState} from '../reducer-utils';
// @ts-ignore
import {jsonToModelPropArray} from '../json-to-model-prop-array';
import {ActionTypes as VisualPipelineActionTypes} from '../visual-pipeline/visual-pipeline-constants';
import type {VisualPipelineAction} from '../visual-pipeline/visual-pipeline-types';
import type {LeadsAction} from './leads-types';
import {ActionTypes} from './leads-constants';

type SchemaState = ListSchemaResponse | null | undefined;
const schemaReducer = (
    state: SchemaState | null | undefined = null,
    action: LeadsAction
): SchemaState => {
    switch (action.type) {
        case ActionTypes.LEADS_SCHEMA_UPDATED:
            return action.payload;
        default:
            return state;
    }
};

type ByIdState = Partial<Record<LeadId, Lead>>;
const byIdReducer = (state: ByIdState | null | undefined = {}, action: LeadsAction): ByIdState => {
    switch (action.type) {
        case ActionTypes.LEADS_FETCH_BY_ID_SUCCESS:
        case ActionTypes.LEADS_UPDATED: {
            const leads = jsonToModelPropArray(action.payload.leads, action.payload, 'leads');

            // @ts-ignore
            return addItemsToByIdState(leads, state);
        }
        default:
            // @ts-ignore
            return state;
    }
};

/*
 * `listItems`
 */
type ListItemsState = Partial<Record<LeadId, ListItem>>;
const listItemsByIdReducer = (
    state: ListItemsState | null | undefined = {},
    action: LeadsAction | VisualPipelineAction
): ListItemsState => {
    switch (action.type) {
        case ActionTypes.LEADS_FETCH_LIST_FOR_CONTACT_SUCCESS: {
            const listItems = action.payload.response.listItems;

            return reduceListItemsByEntityId({...state}, listItems);
        }
        case ActionTypes.LEADS_FETCH_LIST_SUCCESS: {
            return reduceListItemsByEntityId({...state}, action.payload.listItems);
        }
        case VisualPipelineActionTypes.VISUAL_PIPELINE_LIST_ITEMS_REPLACED_FOR_STAGE:
        case VisualPipelineActionTypes.VISUAL_PIPELINE_LIST_ITEMS_ADDED_FOR_STAGE: {
            return reduceListItemsByEntityId({...state}, action.payload.response.listItems);
        }
        default:
            // @ts-ignore
            return state;
    }
};

export type State = {
    byId: ByIdState;
    schema: SchemaState;
    listItemsById: ListItemsState;
};

export const reducer = combineReducers({
    byId: byIdReducer,
    schema: schemaReducer,
    listItemsById: listItemsByIdReducer,
});
